export function formatAmount(amount) {
    if (!amount) return "";

    const integerPart = parseInt(amount, 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    const decimalPart = amount.toString().replace(/^[^\.]+/, "");

    return `${integerPart}${decimalPart}`;
}


export function truncateToTwoDecimals(value) {
    return Math.floor((Number(value) + Number.EPSILON) * 100) / 100;
}


export const regions = [
    { "id": 14, "name": "Toshkent shah" },
    { "id": 1, "name": "Toshkent vil" },
    { "id": 2, "name": "Andijon" },
    { "id": 3, "name": "Buxoro" },
    { "id": 4, "name": "Farg‘ona" },
    { "id": 5, "name": "Jizzax" },
    { "id": 6, "name": "Xorazm" },
    { "id": 7, "name": "Namangan" },
    { "id": 8, "name": "Navoiy" },
    { "id": 9, "name": "Qashqadaryo" },
    { "id": 10, "name": "Qoraqalpog‘iston" },
    { "id": 11, "name": "Samarqand" },
    { "id": 12, "name": "Sirdaryo" },
    { "id": 13, "name": "Surxondaryo" }
]

export const cities = [
    {
        region_id: 14, //Toshkent
        city: [
            { "id": 1, "region_id": 14, "name": "Bektemir tumani" },
            { "id": 2, "region_id": 14, "name": "Chilonzor tumani" },
            { "id": 3, "region_id": 14, "name": "Mirobod tumani" },
            { "id": 4, "region_id": 14, "name": "Mirzo Ulug‘bek tumani" },
            { "id": 5, "region_id": 14, "name": "Sergeli tumani" },
            { "id": 6, "region_id": 14, "name": "Shayxontohur tumani" },
            { "id": 7, "region_id": 14, "name": "Olmazor tumani" },
            { "id": 8, "region_id": 14, "name": "Uchtepa tumani" },
            { "id": 9, "region_id": 14, "name": "Yakkasaroy tumani" },
            { "id": 10, "region_id": 14, "name": "Yashnobod tumani" },
            { "id": 11, "region_id": 14, "name": "Yunusobod tumani" },]
    },
    //Toshkent vil
    {
        region_id: 1,
        city: [
            { "id": 15, "region_id": 1, "name": "Angren shahri" },
            { "id": 16, "region_id": 1, "name": "Bekobod shahri" },
            { "id": 17, "region_id": 1, "name": "Chirchiq shahri" },
            { "id": 18, "region_id": 1, "name": "Ohangaron shahri" },
            { "id": 19, "region_id": 1, "name": "Olmaliq shahri" },
            { "id": 20, "region_id": 1, "name": "Yangiyo‘l shahri" },
            { "id": 21, "region_id": 1, "name": "Bekobod tumani" },
            { "id": 22, "region_id": 1, "name": "Bo‘ka tumani" },
            { "id": 23, "region_id": 1, "name": "Bo‘stonliq tumani" },
            { "id": 24, "region_id": 1, "name": "Chinoz tumani" },
            { "id": 25, "region_id": 1, "name": "Qibray tumani" },
            { "id": 26, "region_id": 1, "name": "Ohangaron tumani" },
            { "id": 27, "region_id": 1, "name": "Oqqo‘rg‘on tumani" },
            { "id": 28, "region_id": 1, "name": "Parkent tumani" },
            { "id": 29, "region_id": 1, "name": "Piskent tumani" },
            { "id": 30, "region_id": 1, "name": "Quyichirchiq tumani" },
            { "id": 31, "region_id": 1, "name": "O‘rta Chirchiq tumani" },
            { "id": 32, "region_id": 1, "name": "Yangiyo‘l tumani" },
            { "id": 33, "region_id": 1, "name": "Yuqorichirchiq tumani" },
            { "id": 34, "region_id": 1, "name": "Zangiota tumani" },]
    },
    //Andijon
    {
        region_id: 2,
        city: [
            { "id": 40, "region_id": 2, "name": "Andijon shahri" },
            { "id": 41, "region_id": 2, "name": "Asaka shahri" },
            { "id": 42, "region_id": 2, "name": "Xonobod shahri" },
            { "id": 43, "region_id": 2, "name": "Andijon tumani" },
            { "id": 44, "region_id": 2, "name": "Asaka tumani" },
            { "id": 45, "region_id": 2, "name": "Baliqchi tumani" },
            { "id": 46, "region_id": 2, "name": "Bo‘z tumani" },
            { "id": 47, "region_id": 2, "name": "Buloqboshi tumani" },
            { "id": 48, "region_id": 2, "name": "Jalaquduq tumani" },
            { "id": 49, "region_id": 2, "name": "Izboskan tumani" },
            { "id": 50, "region_id": 2, "name": "Marhamat tumani" },
            { "id": 51, "region_id": 2, "name": "Oltinko‘l tumani" },
            { "id": 52, "region_id": 2, "name": "Paxtaobod tumani" },
            { "id": 53, "region_id": 2, "name": "Shahrixon tumani" },
            { "id": 54, "region_id": 2, "name": "Ulug‘nor tumani" },
            { "id": 55, "region_id": 2, "name": "Xo‘jaobod tumani" },
            { "id": 56, "region_id": 2, "name": "Qo‘rg‘ontepa tumani" },]
    },
    //Buxoro
    {
        region_id: 3,
        city: [
            { "id": 60, "region_id": 3, "name": "Buxoro shahri" },
            { "id": 61, "region_id": 3, "name": "Kogon shahri" },
            { "id": 62, "region_id": 3, "name": "Buxoro tumani" },
            { "id": 63, "region_id": 3, "name": "G‘ijduvon tumani" },
            { "id": 64, "region_id": 3, "name": "Jondor tumani" },
            { "id": 65, "region_id": 3, "name": "Kogon tumani" },
            { "id": 66, "region_id": 3, "name": "Olot tumani" },
            { "id": 67, "region_id": 3, "name": "Peshku tumani" },
            { "id": 68, "region_id": 3, "name": "Qorako‘l tumani" },
            { "id": 69, "region_id": 3, "name": "Qorovulbozor tumani" },
            { "id": 70, "region_id": 3, "name": "Romitan tumani" },
            { "id": 71, "region_id": 3, "name": "Shofirkon tumani" },
            { "id": 72, "region_id": 3, "name": "Vobkent tumani" },]
    },
    //Farg'ona
    {
        region_id: 4,
        city: [
            { "id": 75, "region_id": 4, "name": "Farg‘ona shahri" },
            { "id": 76, "region_id": 4, "name": "Qo‘qon shahri" },
            { "id": 77, "region_id": 4, "name": "Marg‘ilon shahri" },
            { "id": 78, "region_id": 4, "name": "Beshariq tumani" },
            { "id": 79, "region_id": 4, "name": "Bog‘dod tumani" },
            { "id": 80, "region_id": 4, "name": "Buvayda tumani" },
            { "id": 81, "region_id": 4, "name": "Dang‘ara tumani" },
            { "id": 82, "region_id": 4, "name": "Farg‘ona tumani" },
            { "id": 83, "region_id": 4, "name": "Furqat tumani" },
            { "id": 84, "region_id": 4, "name": "Qo‘shtepa tumani" },
            { "id": 85, "region_id": 4, "name": "Oltiariq tumani" },
            { "id": 86, "region_id": 4, "name": "Rishton tumani" },
            { "id": 87, "region_id": 4, "name": "So‘x tumani" },
            { "id": 88, "region_id": 4, "name": "Toshloq tumani" },
            { "id": 89, "region_id": 4, "name": "Uchko‘prik tumani" },
            { "id": 90, "region_id": 4, "name": "O‘zbekiston tumani" },
            { "id": 91, "region_id": 4, "name": "Yozyovon tumani" },
            { "id": 92, "region_id": 4, "name": "Quva tumani" },
            { "id": 93, "region_id": 4, "name": "Quvasoy shahri" },
        ]
    },
    //Jizzax
    {
        region_id: 5,
        city: [
            { "id": 95, "region_id": 5, "name": "Jizzax shahri" },
            { "id": 96, "region_id": 5, "name": "Arnasoy tumani" },
            { "id": 97, "region_id": 5, "name": "Baxmal tumani" },
            { "id": 98, "region_id": 5, "name": "Do‘stlik tumani" },
            { "id": 99, "region_id": 5, "name": "Forish tumani" },
            { "id": 100, "region_id": 5, "name": "G‘allaorol tumani" },
            { "id": 101, "region_id": 5, "name": "Sharof Rashidov tumani" },
            { "id": 102, "region_id": 5, "name": "Mirzacho‘l tumani" },
            { "id": 103, "region_id": 5, "name": "Paxtakor tumani" },
            { "id": 104, "region_id": 5, "name": "Yangiobod tumani" },
            { "id": 105, "region_id": 5, "name": "Zafarobod tumani" },
            { "id": 106, "region_id": 5, "name": "Zomin tumani" },]
    },
    //Xorazm
    {
        region_id: 6,
        city: [
            { "id": 110, "region_id": 6, "name": "Urganch shahri" },
            { "id": 111, "region_id": 6, "name": "Bog‘ot tumani" },
            { "id": 112, "region_id": 6, "name": "Gurlan tumani" },
            { "id": 113, "region_id": 6, "name": "Xonqa tumani" },
            { "id": 114, "region_id": 6, "name": "Hazorasp tumani" },
            { "id": 115, "region_id": 6, "name": "Qo‘shko‘pir tumani" },
            { "id": 116, "region_id": 6, "name": "Shovot tumani" },
            { "id": 117, "region_id": 6, "name": "Urganch tumani" },
            { "id": 118, "region_id": 6, "name": "Xiva tumani" },
            { "id": 119, "region_id": 6, "name": "Yangiariq tumani" },
            { "id": 120, "region_id": 6, "name": "Yangibozor tumani" },]
    },
    //Namangan
    {
        region_id: 7,
        city: [
            { "id": 125, "region_id": 7, "name": "Namangan shahri" },
            { "id": 126, "region_id": 7, "name": "Chortoq tumani" },
            { "id": 127, "region_id": 7, "name": "Chust tumani" },
            { "id": 128, "region_id": 7, "name": "Kosonsoy tumani" },
            { "id": 129, "region_id": 7, "name": "Mingbuloq tumani" },
            { "id": 130, "region_id": 7, "name": "Namangan tumani" },
            { "id": 131, "region_id": 7, "name": "Norin tumani" },
            { "id": 132, "region_id": 7, "name": "Pop tumani" },
            { "id": 133, "region_id": 7, "name": "To‘raqo‘rg‘on tumani" },
            { "id": 134, "region_id": 7, "name": "Uychi tumani" },
            { "id": 135, "region_id": 7, "name": "Uchqo‘rg‘on tumani" },
            { "id": 136, "region_id": 7, "name": "Yangiqo‘rg‘on tumani" },]
    },
    //Navoiy
    {
        region_id: 8,
        city: [
            { "id": 140, "region_id": 8, "name": "Navoiy shahri" },
            { "id": 141, "region_id": 8, "name": "Zarafshon shahri" },
            { "id": 142, "region_id": 8, "name": "Karmana tumani" },
            { "id": 143, "region_id": 8, "name": "Konimex tumani" },
            { "id": 144, "region_id": 8, "name": "Navbahor tumani" },
            { "id": 145, "region_id": 8, "name": "Nurota tumani" },
            { "id": 146, "region_id": 8, "name": "Qiziltepa tumani" },
            { "id": 147, "region_id": 8, "name": "Tomdi tumani" },
            { "id": 148, "region_id": 8, "name": "Uchquduq tumani" },
            { "id": 149, "region_id": 8, "name": "Xatirchi tumani" },
        ]
    },
    //Qashqadaryo
    {
        region_id: 9,
        city: [
            { "id": 150, "region_id": 9, "name": "Qarshi shahri" },
            { "id": 151, "region_id": 9, "name": "Dehqonobod tumani" },
            { "id": 152, "region_id": 9, "name": "G‘uzor tumani" },
            { "id": 153, "region_id": 9, "name": "Kasbi tumani" },
            { "id": 154, "region_id": 9, "name": "Kitob tumani" },
            { "id": 155, "region_id": 9, "name": "Koson tumani" },
            { "id": 156, "region_id": 9, "name": "Mirishkor tumani" },
            { "id": 157, "region_id": 9, "name": "Muborak tumani" },
            { "id": 158, "region_id": 9, "name": "Nishon tumani" },
            { "id": 159, "region_id": 9, "name": "Qamashi tumani" },
            { "id": 160, "region_id": 9, "name": "Shahrisabz tumani" },
            { "id": 161, "region_id": 9, "name": "Yakkabog‘ tumani" },
            { "id": 162, "region_id": 9, "name": "Chiroqchi tumani" },]
    },
    //Qoraqalpog‘iston
    {
        region_id: 10,
        city: [
            { id: 216, region_id: 10, name: "Nukus shahri" },
            { id: 229, region_id: 10, name: "Nukus tumani" },
            { id: 217, region_id: 10, name: "Amudaryo tumani" },
            { id: 218, region_id: 10, name: "Beruniy tumani" },
            { id: 219, region_id: 10, name: "Chimboy tumani" },
            { id: 220, region_id: 10, name: "Ellikqal‘a tumani" },
            { id: 221, region_id: 10, name: "Kegeyli tumani" },
            { id: 222, region_id: 10, name: "Mo‘ynoq tumani" },
            { id: 223, region_id: 10, name: "Qonliko‘l tumani" },
            { id: 224, region_id: 10, name: "Qorao‘zak tumani" },
            { id: 225, region_id: 10, name: "Shumanay tumani" },
            { id: 226, region_id: 10, name: "To‘rtko‘l tumani" },
            { id: 227, region_id: 10, name: "Taxtako‘pir tumani" },
            { id: 228, region_id: 10, name: "Xo‘jayli tumani" },
            { id: 230, region_id: 10, name: "Taxiatosh tumani" },
            { id: 231, region_id: 10, name: "Qon'girot tumani" },
            { id: 232, region_id: 10, name: "Bo'zatov tumani" },
        ]
    },
    //Samarqand
    {
        region_id: 11,
        city: [
            { "id": 165, "region_id": 11, "name": "Samarqand shahri" },
            { "id": 166, "region_id": 11, "name": "Bulung‘ur tumani" },
            { "id": 167, "region_id": 11, "name": "Ishtixon tumani" },
            { "id": 168, "region_id": 11, "name": "Jomboy tumani" },
            { "id": 169, "region_id": 11, "name": "Kattaqo‘rg‘on shahri" },
            { "id": 170, "region_id": 11, "name": "Kattaqo‘rg‘on tumani" },
            { "id": 171, "region_id": 11, "name": "Narpay tumani" },
            { "id": 172, "region_id": 11, "name": "Nurobod tumani" },
            { "id": 173, "region_id": 11, "name": "Oqdaryo tumani" },
            { "id": 174, "region_id": 11, "name": "Paxtachi tumani" },
            { "id": 175, "region_id": 11, "name": "Past Darg‘om tumani" },
            { "id": 176, "region_id": 11, "name": "Payariq tumani" },
            { "id": 177, "region_id": 11, "name": "Samarqand tumani" },
            { "id": 178, "region_id": 11, "name": "Toyloq tumani" },
            { "id": 179, "region_id": 11, "name": "Urgut tumani" },
        ]
    },
    //Sirdaryo
    {
        region_id: 12,
        city: [
            { "id": 185, "region_id": 12, "name": "Guliston shahri" },
            { "id": 186, "region_id": 12, "name": "Baxt tumani" },
            { "id": 187, "region_id": 12, "name": "Boyovut tumani" },
            { "id": 188, "region_id": 12, "name": "Guliston tumani" },
            { "id": 189, "region_id": 12, "name": "Mirzaobod tumani" },
            { "id": 190, "region_id": 12, "name": "Oqoltin tumani" },
            { "id": 191, "region_id": 12, "name": "Sayxunobod tumani" },
            { "id": 192, "region_id": 12, "name": "Sardoba tumani" },
            { "id": 193, "region_id": 12, "name": "Shirin shahri" },
            { "id": 194, "region_id": 12, "name": "Xovos tumani" },
            { "id": 195, "region_id": 12, "name": "Yangiyer shahri" },
            { "id": 196, "region_id": 12, "name": "Sirdaryo tumani" },]
    },
    //Surxandaryo
    {
        region_id: 13,
        city: [
            { "id": 200, "region_id": 13, "name": "Termiz shahri" },
            { "id": 201, "region_id": 13, "name": "Angor tumani" },
            { "id": 202, "region_id": 13, "name": "Bandixon tumani" },
            { "id": 203, "region_id": 13, "name": "Boysun tumani" },
            { "id": 204, "region_id": 13, "name": "Denov tumani" },
            { "id": 205, "region_id": 13, "name": "Jarqo‘rg‘on tumani" },
            { "id": 206, "region_id": 13, "name": "Muzrabot tumani" },
            { "id": 207, "region_id": 13, "name": "Oltinsoy tumani" },
            { "id": 208, "region_id": 13, "name": "Qiziriq tumani" },
            { "id": 209, "region_id": 13, "name": "Sherobod tumani" },
            { "id": 210, "region_id": 13, "name": "Sho‘rchi tumani" },
            { "id": 211, "region_id": 13, "name": "Sariosiyo tumani" },
            { "id": 212, "region_id": 13, "name": "Termiz tumani" },
            { "id": 213, "region_id": 13, "name": "Uzun tumani" }]
    },
]


export const city_full = [
    //Toshkent
    { "id": 1, "region_id": 14, "name": "Bektemir tumani" },
    { "id": 2, "region_id": 14, "name": "Chilonzor tumani" },
    { "id": 3, "region_id": 14, "name": "Mirobod tumani" },
    { "id": 4, "region_id": 14, "name": "Mirzo Ulug‘bek tumani" },
    { "id": 5, "region_id": 14, "name": "Sergeli tumani" },
    { "id": 6, "region_id": 14, "name": "Shayxontohur tumani" },
    { "id": 7, "region_id": 14, "name": "Olmazor tumani" },
    { "id": 8, "region_id": 14, "name": "Uchtepa tumani" },
    { "id": 9, "region_id": 14, "name": "Yakkasaroy tumani" },
    { "id": 10, "region_id": 14, "name": "Yashnobod tumani" },
    { "id": 11, "region_id": 14, "name": "Yunusobod tumani" },
    //Toshkent vil
    { "id": 15, "region_id": 1, "name": "Angren shahri" },
    { "id": 16, "region_id": 1, "name": "Bekobod shahri" },
    { "id": 17, "region_id": 1, "name": "Chirchiq shahri" },
    { "id": 18, "region_id": 1, "name": "Ohangaron shahri" },
    { "id": 19, "region_id": 1, "name": "Olmaliq shahri" },
    { "id": 20, "region_id": 1, "name": "Yangiyo‘l shahri" },
    { "id": 21, "region_id": 1, "name": "Bekobod tumani" },
    { "id": 22, "region_id": 1, "name": "Bo‘ka tumani" },
    { "id": 23, "region_id": 1, "name": "Bo‘stonliq tumani" },
    { "id": 24, "region_id": 1, "name": "Chinoz tumani" },
    { "id": 25, "region_id": 1, "name": "Qibray tumani" },
    { "id": 26, "region_id": 1, "name": "Ohangaron tumani" },
    { "id": 27, "region_id": 1, "name": "Oqqo‘rg‘on tumani" },
    { "id": 28, "region_id": 1, "name": "Parkent tumani" },
    { "id": 29, "region_id": 1, "name": "Piskent tumani" },
    { "id": 30, "region_id": 1, "name": "Quyichirchiq tumani" },
    { "id": 31, "region_id": 1, "name": "O‘rta Chirchiq tumani" },
    { "id": 32, "region_id": 1, "name": "Yangiyo‘l tumani" },
    { "id": 33, "region_id": 1, "name": "Yuqorichirchiq tumani" },
    { "id": 34, "region_id": 1, "name": "Zangiota tumani" },
    //Andijon
    { "id": 40, "region_id": 2, "name": "Andijon shahri" },
    { "id": 41, "region_id": 2, "name": "Asaka shahri" },
    { "id": 42, "region_id": 2, "name": "Xonobod shahri" },
    { "id": 43, "region_id": 2, "name": "Andijon tumani" },
    { "id": 44, "region_id": 2, "name": "Asaka tumani" },
    { "id": 45, "region_id": 2, "name": "Baliqchi tumani" },
    { "id": 46, "region_id": 2, "name": "Bo‘z tumani" },
    { "id": 47, "region_id": 2, "name": "Buloqboshi tumani" },
    { "id": 48, "region_id": 2, "name": "Jalaquduq tumani" },
    { "id": 49, "region_id": 2, "name": "Izboskan tumani" },
    { "id": 50, "region_id": 2, "name": "Marhamat tumani" },
    { "id": 51, "region_id": 2, "name": "Oltinko‘l tumani" },
    { "id": 52, "region_id": 2, "name": "Paxtaobod tumani" },
    { "id": 53, "region_id": 2, "name": "Shahrixon tumani" },
    { "id": 54, "region_id": 2, "name": "Ulug‘nor tumani" },
    { "id": 55, "region_id": 2, "name": "Xo‘jaobod tumani" },
    { "id": 56, "region_id": 2, "name": "Qo‘rg‘ontepa tumani" },
    //Buxoro
    { "id": 60, "region_id": 3, "name": "Buxoro shahri" },
    { "id": 61, "region_id": 3, "name": "Kogon shahri" },
    { "id": 62, "region_id": 3, "name": "Buxoro tumani" },
    { "id": 63, "region_id": 3, "name": "G‘ijduvon tumani" },
    { "id": 64, "region_id": 3, "name": "Jondor tumani" },
    { "id": 65, "region_id": 3, "name": "Kogon tumani" },
    { "id": 66, "region_id": 3, "name": "Olot tumani" },
    { "id": 67, "region_id": 3, "name": "Peshku tumani" },
    { "id": 68, "region_id": 3, "name": "Qorako‘l tumani" },
    { "id": 69, "region_id": 3, "name": "Qorovulbozor tumani" },
    { "id": 70, "region_id": 3, "name": "Romitan tumani" },
    { "id": 71, "region_id": 3, "name": "Shofirkon tumani" },
    { "id": 72, "region_id": 3, "name": "Vobkent tumani" },
    //Farg'ona
    { "id": 75, "region_id": 4, "name": "Farg‘ona shahri" },
    { "id": 76, "region_id": 4, "name": "Qo‘qon shahri" },
    { "id": 77, "region_id": 4, "name": "Marg‘ilon shahri" },
    { "id": 78, "region_id": 4, "name": "Beshariq tumani" },
    { "id": 79, "region_id": 4, "name": "Bog‘dod tumani" },
    { "id": 80, "region_id": 4, "name": "Buvayda tumani" },
    { "id": 81, "region_id": 4, "name": "Dang‘ara tumani" },
    { "id": 82, "region_id": 4, "name": "Farg‘ona tumani" },
    { "id": 83, "region_id": 4, "name": "Furqat tumani" },
    { "id": 84, "region_id": 4, "name": "Qo‘shtepa tumani" },
    { "id": 85, "region_id": 4, "name": "Oltiariq tumani" },
    { "id": 86, "region_id": 4, "name": "Rishton tumani" },
    { "id": 87, "region_id": 4, "name": "So‘x tumani" },
    { "id": 88, "region_id": 4, "name": "Toshloq tumani" },
    { "id": 89, "region_id": 4, "name": "Uchko‘prik tumani" },
    { "id": 90, "region_id": 4, "name": "O‘zbekiston tumani" },
    { "id": 91, "region_id": 4, "name": "Yozyovon tumani" },
    { "id": 92, "region_id": 4, "name": "Quva tumani" },
    { "id": 93, "region_id": 4, "name": "Quvasoy shahri" },
    //Jizzax
    { "id": 95, "region_id": 5, "name": "Jizzax shahri" },
    { "id": 96, "region_id": 5, "name": "Arnasoy tumani" },
    { "id": 97, "region_id": 5, "name": "Baxmal tumani" },
    { "id": 98, "region_id": 5, "name": "Do‘stlik tumani" },
    { "id": 99, "region_id": 5, "name": "Forish tumani" },
    { "id": 100, "region_id": 5, "name": "G‘allaorol tumani" },
    { "id": 101, "region_id": 5, "name": "Sharof Rashidov tumani" },
    { "id": 102, "region_id": 5, "name": "Mirzacho‘l tumani" },
    { "id": 103, "region_id": 5, "name": "Paxtakor tumani" },
    { "id": 104, "region_id": 5, "name": "Yangiobod tumani" },
    { "id": 105, "region_id": 5, "name": "Zafarobod tumani" },
    { "id": 106, "region_id": 5, "name": "Zomin tumani" },
    //Xorazm
    { "id": 110, "region_id": 6, "name": "Urganch shahri" },
    { "id": 111, "region_id": 6, "name": "Bog‘ot tumani" },
    { "id": 112, "region_id": 6, "name": "Gurlan tumani" },
    { "id": 113, "region_id": 6, "name": "Xonqa tumani" },
    { "id": 114, "region_id": 6, "name": "Hazorasp tumani" },
    { "id": 115, "region_id": 6, "name": "Qo‘shko‘pir tumani" },
    { "id": 116, "region_id": 6, "name": "Shovot tumani" },
    { "id": 117, "region_id": 6, "name": "Urganch tumani" },
    { "id": 118, "region_id": 6, "name": "Xiva tumani" },
    { "id": 119, "region_id": 6, "name": "Yangiariq tumani" },
    { "id": 120, "region_id": 6, "name": "Yangibozor tumani" },
    //Namangan
    { "id": 125, "region_id": 7, "name": "Namangan shahri" },
    { "id": 126, "region_id": 7, "name": "Chortoq tumani" },
    { "id": 127, "region_id": 7, "name": "Chust tumani" },
    { "id": 128, "region_id": 7, "name": "Kosonsoy tumani" },
    { "id": 129, "region_id": 7, "name": "Mingbuloq tumani" },
    { "id": 130, "region_id": 7, "name": "Namangan tumani" },
    { "id": 131, "region_id": 7, "name": "Norin tumani" },
    { "id": 132, "region_id": 7, "name": "Pop tumani" },
    { "id": 133, "region_id": 7, "name": "To‘raqo‘rg‘on tumani" },
    { "id": 134, "region_id": 7, "name": "Uychi tumani" },
    { "id": 135, "region_id": 7, "name": "Uchqo‘rg‘on tumani" },
    { "id": 136, "region_id": 7, "name": "Yangiqo‘rg‘on tumani" },
    //Navoiy
    { "id": 140, "region_id": 8, "name": "Navoiy shahri" },
    { "id": 141, "region_id": 8, "name": "Zarafshon shahri" },
    { "id": 142, "region_id": 8, "name": "Karmana tumani" },
    { "id": 143, "region_id": 8, "name": "Konimex tumani" },
    { "id": 144, "region_id": 8, "name": "Navbahor tumani" },
    { "id": 145, "region_id": 8, "name": "Nurota tumani" },
    { "id": 146, "region_id": 8, "name": "Qiziltepa tumani" },
    { "id": 147, "region_id": 8, "name": "Tomdi tumani" },
    { "id": 148, "region_id": 8, "name": "Uchquduq tumani" },
    { "id": 149, "region_id": 8, "name": "Xatirchi tumani" },
    //Qashqadaryo
    { "id": 150, "region_id": 9, "name": "Qarshi shahri" },
    { "id": 151, "region_id": 9, "name": "Dehqonobod tumani" },
    { "id": 152, "region_id": 9, "name": "G‘uzor tumani" },
    { "id": 153, "region_id": 9, "name": "Kasbi tumani" },
    { "id": 154, "region_id": 9, "name": "Kitob tumani" },
    { "id": 155, "region_id": 9, "name": "Koson tumani" },
    { "id": 156, "region_id": 9, "name": "Mirishkor tumani" },
    { "id": 157, "region_id": 9, "name": "Muborak tumani" },
    { "id": 158, "region_id": 9, "name": "Nishon tumani" },
    { "id": 159, "region_id": 9, "name": "Qamashi tumani" },
    { "id": 160, "region_id": 9, "name": "Shahrisabz tumani" },
    { "id": 161, "region_id": 9, "name": "Yakkabog‘ tumani" },
    { "id": 162, "region_id": 9, "name": "Chiroqchi tumani" },
    //Samarqand
    { "id": 165, "region_id": 11, "name": "Samarqand shahri" },
    { "id": 166, "region_id": 11, "name": "Bulung‘ur tumani" },
    { "id": 167, "region_id": 11, "name": "Ishtixon tumani" },
    { "id": 168, "region_id": 11, "name": "Jomboy tumani" },
    { "id": 169, "region_id": 11, "name": "Kattaqo‘rg‘on shahri" },
    { "id": 170, "region_id": 11, "name": "Kattaqo‘rg‘on tumani" },
    { "id": 171, "region_id": 11, "name": "Narpay tumani" },
    { "id": 172, "region_id": 11, "name": "Nurobod tumani" },
    { "id": 173, "region_id": 11, "name": "Oqdaryo tumani" },
    { "id": 174, "region_id": 11, "name": "Paxtachi tumani" },
    { "id": 175, "region_id": 11, "name": "Past Darg‘om tumani" },
    { "id": 176, "region_id": 11, "name": "Payariq tumani" },
    { "id": 177, "region_id": 11, "name": "Samarqand tumani" },
    { "id": 178, "region_id": 11, "name": "Toyloq tumani" },
    { "id": 179, "region_id": 11, "name": "Urgut tumani" },
    //Sirdaryo
    { "id": 185, "region_id": 12, "name": "Guliston shahri" },
    { "id": 186, "region_id": 12, "name": "Baxt tumani" },
    { "id": 187, "region_id": 12, "name": "Boyovut tumani" },
    { "id": 188, "region_id": 12, "name": "Guliston tumani" },
    { "id": 189, "region_id": 12, "name": "Mirzaobod tumani" },
    { "id": 190, "region_id": 12, "name": "Oqoltin tumani" },
    { "id": 191, "region_id": 12, "name": "Sayxunobod tumani" },
    { "id": 192, "region_id": 12, "name": "Sardoba tumani" },
    { "id": 193, "region_id": 12, "name": "Shirin shahri" },
    { "id": 194, "region_id": 12, "name": "Xovos tumani" },
    { "id": 195, "region_id": 12, "name": "Yangiyer shahri" },
    { "id": 196, "region_id": 12, "name": "Sirdaryo tumani" },
    //Surxandaryo
    { "id": 200, "region_id": 13, "name": "Termiz shahri" },
    { "id": 201, "region_id": 13, "name": "Angor tumani" },
    { "id": 202, "region_id": 13, "name": "Bandixon tumani" },
    { "id": 203, "region_id": 13, "name": "Boysun tumani" },
    { "id": 204, "region_id": 13, "name": "Denov tumani" },
    { "id": 205, "region_id": 13, "name": "Jarqo‘rg‘on tumani" },
    { "id": 206, "region_id": 13, "name": "Muzrabot tumani" },
    { "id": 207, "region_id": 13, "name": "Oltinsoy tumani" },
    { "id": 208, "region_id": 13, "name": "Qiziriq tumani" },
    { "id": 209, "region_id": 13, "name": "Sherobod tumani" },
    { "id": 210, "region_id": 13, "name": "Sho‘rchi tumani" },
    { "id": 211, "region_id": 13, "name": "Sariosiyo tumani" },
    { "id": 212, "region_id": 13, "name": "Termiz tumani" },
    { "id": 213, "region_id": 13, "name": "Uzun tumani" },
    //Qoraqalpog‘iston
    { id: 216, region_id: 10, name: "Nukus shahri" },
    { id: 229, region_id: 10, name: "Nukus tumani" },
    { id: 217, region_id: 10, name: "Amudaryo tumani" },
    { id: 218, region_id: 10, name: "Beruniy tumani" },
    { id: 219, region_id: 10, name: "Chimboy tumani" },
    { id: 220, region_id: 10, name: "Ellikqal‘a tumani" },
    { id: 221, region_id: 10, name: "Kegeyli tumani" },
    { id: 222, region_id: 10, name: "Mo‘ynoq tumani" },
    { id: 223, region_id: 10, name: "Qonliko‘l tumani" },
    { id: 224, region_id: 10, name: "Qorao‘zak tumani" },
    { id: 225, region_id: 10, name: "Shumanay tumani" },
    { id: 226, region_id: 10, name: "To‘rtko‘l tumani" },
    { id: 227, region_id: 10, name: "Taxtako‘pir tumani" },
    { id: 228, region_id: 10, name: "Xo‘jayli tumani" },
    { id: 230, region_id: 10, name: "Taxiatosh tumani" },
    { id: 231, region_id: 10, name: "Qon'girot tumani" },
    { id: 232, region_id: 10, name: "Bo'zatov tumani" },
]